import {
	type GroupAndRegularAlert,
	type SNRActionType,
	type SNRPredictionType,
	type SNRStatusType,
} from '@atlassian/eoc-alert-common';
import { fetch } from '@atlassian/eoc-fetch';

import type { SNRExplanationResponseType } from '../../../common/types';
import { withAIOpsPrefix } from '../../../common/utils';
export const getSNRExplanation = ({ id, type }: { id: string; type: 'alert' | 'group' }) => {
	return fetch<SNRExplanationResponseType>(
		withAIOpsPrefix(`/v1/snr-insights/explanation/${id}?type=${type}`),
		{
			exactUrl: true,
		},
	);
};

export const updateSNRState = ({
	id,
	status,
	type,
	prediction,
}: {
	id: string;
	prediction: SNRPredictionType;
	status: SNRStatusType;
	type: 'alert' | 'group';
}) => {
	return fetch<{
		failedRecords?: number;
		snrResponse: GroupAndRegularAlert | null;
	}>(withAIOpsPrefix(`/v1/alert-insights/prediction-action`), {
		method: 'POST',
		body: {
			id,
			status,
			type,
			prediction,
		},
		exactUrl: true,
	});
};

export const updateSNRStateV2 = ({
	id,
	status,
	type,
	prevPrediction,
	newPrediction,
	action,
}: {
	action: SNRActionType;
	id: string;
	newPrediction: SNRPredictionType;
	prevPrediction: SNRPredictionType;
	status: SNRStatusType;
	type: 'alert' | 'group';
}) => {
	return fetch<{
		failedRecords?: number;
		snrResponse: GroupAndRegularAlert | null;
	}>(withAIOpsPrefix(`/v1/alert-insights/prediction-action`), {
		method: 'POST',
		body: {
			id,
			status,
			type,
			prevPrediction,
			newPrediction,
			action,
		},
		exactUrl: true,
	});
};
